import { render, staticRenderFns } from "./RecentUpdatedAccounts.vue?vue&type=template&id=282452ca"
import script from "./RecentUpdatedAccounts.vue?vue&type=script&lang=js"
export * from "./RecentUpdatedAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports